var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Box } from "../..";
export var SliderRail = function (_a) {
    var getRailProps = _a.getRailProps, height = _a.height;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, __assign({ lss: {
                position: 'absolute',
                width: '100%',
                height: height,
                transform: 'translate(0%, -50%)',
                borderRadius: 'md',
                cursor: 'pointer'
            } }, getRailProps())),
        React.createElement(Box, { lss: {
                position: 'absolute',
                width: '100%',
                height: height,
                transform: 'translate(0%, -50%)',
                borderRadius: 'md',
                pointerEvents: 'none',
                bg: 'gray600'
            } })));
};
//# sourceMappingURL=SliderRail.js.map